import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-embed',
  templateUrl: './embed.component.html',
  styleUrls: ['./embed.component.scss']
})
export class EmbedComponent  {
  @Input() videoId: string = '';          // Dynamic video ID
  customWidth: string = '640';   // Default width
  customHeight: string = '360';  // Default height
  menuOpen = false;
}
